<template>
    <v-btn small text @click="copyURL">
        <v-icon small class="mr-1">content_copy</v-icon>
        Share link
    </v-btn>
</template>

<script>
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import {NOTIFICATION_NS} from "@/store/modules/notification/constants";
    import {mapActions} from "vuex";

    export default {
        name: "ShareLinkButton",
        methods: {
            ...mapActions(NOTIFICATION_NS, [
                'addNotification'
            ]),
            copyURL() {
                const urlParam = this.$store.getters[`${SEARCH_NS}/shareUrlParam`];

                navigator.clipboard.writeText(window.location.host + "/share/" + urlParam);

                this.addNotification({
                    message :"A link to the current search has been copied in your clipboard!"
                });
            }
        }
    }
</script>